module.exports = __webpack_public_path__ + "img/jg.c7ba95bf.png";